interface RankingPaginationProps {
  page: number;
  pages: number;
  onPageChange: (page: number) => void;
}

export function RankingPagination({ page, pages, onPageChange }: RankingPaginationProps) {
  if (pages <= 1) return null;

  return (
    <nav className="ranking-pager" aria-label="Ranking pagination">
      <button
        type="button"
        className="ranking-pager-btn"
        disabled={page <= 1}
        aria-label="Previous page"
        onClick={() => onPageChange(page - 1)}
      >
        ‹
      </button>
      <span className="ranking-pager-label">
        {page}/{pages}
      </span>
      <button
        type="button"
        className="ranking-pager-btn"
        disabled={page >= pages}
        aria-label="Next page"
        onClick={() => onPageChange(page + 1)}
      >
        ›
      </button>
    </nav>
  );
}
